(function() {
  if (window.innerWidth >= 768) return;

  let savedScrollY = 0;
  let isBlocking = false;

  // Блокируем скролл
  window.addEventListener('scroll', function() {
    if (isBlocking) window.scrollTo({ top: savedScrollY, behavior: 'instant' });
  }, { passive: false });

  const origScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function(x, y) {
    if (isBlocking) return;
    origScrollTo(x, y);
  };

  const origScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function(...args) {
    if (isBlocking) return;
    origScrollIntoView.apply(this, args);
  };

  function getMainImage() {
    // Ищем главное фото которое тема показывает в галерее
    const selectors = [
      '.product__media img',
      '.product-media-container img',
      '[data-media-type="image"] img',
      '.product__photo img',
      'li.product__media-item:first-child img'
    ];
    for (const sel of selectors) {
      const img = document.querySelector(sel);
      if (img && img.src) return img.src;
    }
    return null;
  }

  function showPreview(colorName) {
    let preview = document.getElementById('mobile-swatch-preview');
    if (!preview) {
      preview = document.createElement('div');
      preview.id = 'mobile-swatch-preview';
      preview.style.cssText = 'margin-top:12px;display:flex;align-items:center;gap:12px;padding:6px 0;';
      const wrapper = document.querySelector('input.swatch-input__input')?.closest('fieldset');
      if (wrapper) wrapper.after(preview);
    }

    // Берём фото через небольшую задержку — тема успевает переключить галерею
    setTimeout(() => {
      const imgSrc = getMainImage();
      if (imgSrc) {
        preview.style.display = 'flex';
        preview.innerHTML = `
          <img src="${imgSrc}" style="width:72px;height:72px;object-fit:cover;border-radius:8px;border:1px solid #e0e0e0;flex-shrink:0;" />
          <span style="font-size:14px;font-weight:500;color:#333;">${colorName}</span>
        `;
      }
    }, 400);
  }

  function attachListeners() {
    document.querySelectorAll('input.swatch-input__input').forEach(input => {
      if (input.dataset.pa) return;
      input.dataset.pa = '1';

      input.addEventListener('change', function() {
        savedScrollY = window.scrollY;
        isBlocking = true;

        const colorName = this.value || '';
        showPreview(colorName);

        setTimeout(() => { isBlocking = false; }, 2000);
      });
    });
  }

  const observer = new MutationObserver(() => {
    attachListeners();
    const checked = document.querySelector('input.swatch-input__input:checked');
    if (checked && !document.getElementById('mobile-swatch-preview')) {
      showPreview(checked.value);
    }
  });

  setTimeout(() => {
    attachListeners();
    observer.observe(document.body, { childList: true, subtree: true });
  }, 300);
})();